import {
	getImageBase64,
	getBackground
	, getThemePic
} from "@/views/home/slidePPT/use/methods"
import {
	pathToBase64,
} from '@/utils'

export default async function (data) {
	const node = data.node;
	const title = node.title;
	const serial = data.num;
	const color = data.color;
	const id = Math.random().toString(36).slice(-8);
	const background = await getBackground(data?.customTheme, 'theme')


	return {
		"id": id,
		"elements": [{
			"type": "text",
			"id": "b6bnmDd9DO",
			"width": 354.37,
			"height": 108.55,
			"left": 21.6,
			"top": 136.03,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#333",
			"content": `<p style=\"text-align: justify;\"><span style=\"color: #FEE6AE;font-size: 81.63px;font-family: Arial;text-shadow: 2.21px 2.21px 3.13px #000000;\">PART&nbsp;${serial}</span></p>`,
			"lineHeight": 1,
			"outline": {
				"color": "#000",
				"width": 0,
				"style": "solid"
			},
			"fill": "",
			"vertical": false
		},
		{
			"type": "text",
			"id": "CcDMMHIY2-",
			"width": 444.81,
			"height": 68.16,
			"left": 21.6,
			"top": 228.76999999999998,
			"rotate": 0,
			"defaultFontName": "Microsoft Yahei",
			"defaultColor": "#333",
			"content": `<p style=\"text-align: justify;\"><strong><span style=\"font-size: 48.98px;\"><span style=\"font-family: Arial;\"><span style=\"color: rgba(255,255,255,1);\">${title}</span></span></span></strong></p>`,
			"lineHeight": 1,
			"outline": {
				"color": "#000",
				"width": 0,
				"style": "solid"
			},
			"fill": "",
			"vertical": false
		}
		],
		background
	};

}